module.exports = __webpack_public_path__ + "static/media/facebook-light.78989e30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/facebook-light.svg
// module id = 431
// module chunks = 0